import React from 'react'
import { Pagination as PaginationComponent, PageSection as Section } from '@superhi/design'
import { useRouter } from 'next/router'

import { useScrollToTop } from '../../ScrollToTop'

import { getNumPages } from './utils'

import { buildQuery } from 'src/routing'

type PaginationQuery = {
  page?: string | number
  perPage?: string | number
}

export type Props = {
  query: PaginationQuery
  numResults: number
  perPage: number
}

function Pagination({ query, numResults, perPage }: Props) {
  const router = useRouter()
  const numPages = getNumPages(parseInt(query.perPage as string) || perPage, numResults)
  useScrollToTop(query.page)

  return numPages > 1 ? (
    <Section collapseBottomPadding noTopPadding>
      <PaginationComponent
        currentPage={parseInt(query.page as string) || 1}
        numPages={numPages}
        createUrlFn={(page) => `${router.pathname}?${buildQuery({ ...query, page })}`}
      />
    </Section>
  ) : null
}

export default Pagination
